import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Table,
  TimePicker,
  Typography,
  Space,
  InputNumber,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import React, { Fragment, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  addShift,
  loadAllShift,
} from "../../redux/rtk/features/shift/shiftSlice";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

dayjs.extend(utc);
dayjs.extend(timezone);

function CustomTable({ list, loading, onEdit }) {
  const [columnsToShow, setColumnsToShow] = useState([]);

  const columns = [
    {
      id: 1,
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
    },
    {
      id: 2,
      title: "Name",
      dataIndex: "ShiftName",
      key: "ShiftName",
    },
    {
      id: 3,
      title: "Start Time",
      dataIndex: "FormattedStartTime",
      key: "FormattedStartTime",
    },
    {
      id: 4,
      title: "End Time",
      dataIndex: "FormattedEndTime",
      key: "FormattedEndTime",
    },
    {
      id: 5,
      title: "Working Hours",
      dataIndex: "FormattedWorkingHours",
      key: "FormattedWorkingHours",
    },
    {
      id: 6,
      title: "Punch Grace",
      dataIndex: "PunchGraceMinites",
      key: "PunchGraceMinites",
      render: (value) => `${value} min`,
    },
    {
      id: 7,
      title: "Lunch Hours",
      dataIndex: "LunchHours",
      key: "LunchHours",
      render: (value) => `${value} hrs`,
    },
    {
      id: 7,
      title: "Action",
      dataIndex: "ShiftId",
      key: "action",
      render: (id, record) => (
        <Space>
          {/* <ViewBtn path={`/admin/shift/${id}/`} /> */}
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onEdit(record)}
          />
        </Space>
      ),
    },
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  const addKeys = (arr) =>
    arr.map((i, index) => ({ ...i, key: i.ShiftId, serial: index + 1 }));

  return (
    <>
      <div className="text-center my-2 flex justify-between">
        <h5 className="department-list-title text-color-2 text-xl mb-2">
          Shift List
        </h5>
        {list && (
          <div>
            <CsvLinkBtn>
              <CSVLink
                data={list}
                className="btn btn-dark btn-sm mb-1"
                filename="shift"
              >
                Download CSV
              </CSVLink>
            </CsvLinkBtn>
          </div>
        )}
      </div>

      {list && (
        <div
          className="shift-table-actions"
          style={{
            marginBottom: "30px",
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
          }}
        >
          <ColVisibilityDropdown
            options={columns}
            columns={columns}
            columnsToShowHandler={columnsToShowHandler}
          />
        </div>
      )}

      {loading ? (
        <div className="text-center py-8">
          <div className="ant-spin ant-spin-lg ant-spin-spinning">
            <span className="ant-spin-dot ant-spin-dot-spin">
              <i className="ant-spin-dot-item"></i>
              <i className="ant-spin-dot-item"></i>
              <i className="ant-spin-dot-item"></i>
              <i className="ant-spin-dot-item"></i>
            </span>
          </div>
          <p className="mt-4 text-gray-600">Loading shifts...</p>
        </div>
      ) : !list || list.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-600">No shifts found.</p>
        </div>
      ) : (
      <Table
          scroll={{ x: true, y: "100%" }}
          pagination={{
            defaultPageSize: 20,
          }}
        columns={columnsToShow}
        dataSource={list ? addKeys(list) : []}
          className="shift-table"
      />
      )}
    </>
  );
}

const AddShift = ({ drawer }) => {
  const { list: shiftList, loading } = useSelector((state) => state.shift);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentShiftId, setCurrentShiftId] = useState(null); // Initialize as null to catch issues

  useEffect(() => {
    dispatch(loadAllShift());
  }, [dispatch]);

  const handleEdit = (record) => {
    // console.log("Editing record:", record); // Debug: Log the record to verify values
    setIsEditMode(true);
    const shiftId = record.ShiftId;
    // console.log("Setting currentShiftId to:", shiftId); // Debug: Log the ID being set
    setCurrentShiftId(shiftId);

    // Use FormattedStartTime and FormattedEndTime since they match the displayed values
    const startTime = record.FormattedStartTime; // e.g., "10:00"
    const endTime = record.FormattedEndTime; // e.g., "18:00"
const LunchStartTime = record.FormattedLunchStartTime; // e.g., "10:00"
    const LunchEndTime = record.FormattedLunchEndTime; 
    // Parse the times in HH:mm format since that's what the table shows
    const parsedStartTime = dayjs(startTime, "HH:mm");
    const parsedEndTime = dayjs(endTime, "HH:mm");
    const parsedLunchStartTime = dayjs(LunchStartTime, "HH:mm");
    const parsedLunchEndTime = dayjs(LunchEndTime, "HH:mm");
    // console.log("Parsed StartTime:", parsedStartTime.format("HH:mm")); // Debug
    // console.log("Parsed EndTime:", parsedEndTime.format("HH:mm")); // Debug

    form.setFieldsValue({
      ShiftName: record.ShiftName,
      StartTime: parsedStartTime.isValid() ? parsedStartTime : null,
      EndTime: parsedEndTime.isValid() ? parsedEndTime : null,
      LunchStartTime: parsedLunchStartTime.isValid()
        ? parsedLunchStartTime
        : null,
      LunchEndTime: parsedLunchEndTime.isValid() ? parsedLunchEndTime : null,
      PunchGraceMinites: record.PunchGraceMinites || 0,
    });
  };

  const resetForm = () => {
    form.resetFields();
    setIsEditMode(false);
    setCurrentShiftId(null);
  };

  const onFinish = async (values) => {
    setLoader(true);
    try {
      const shiftIdToUse = isEditMode && currentShiftId ? currentShiftId : 0;

      const shiftData = {
        ShiftId: shiftIdToUse, // Use shiftIdToUse based on isEditMode
        //   CompanyId: 1, // Assuming CompanyId is fixed; adjust if dynamic
        ShiftName: values.ShiftName,
        StartTime: dayjs(values.StartTime).format("HH:mm:ss"),
        EndTime: dayjs(values.EndTime).format("HH:mm:ss"),
        LunchStartTime: dayjs(values.LunchStartTime).format("HH:mm:ss"),
        LunchEndTime: dayjs(values.LunchEndTime).format("HH:mm:ss"),
        PunchGraceMinites: values.PunchGraceMinites || 0, // Include PunchGraceMinites from form
        DataStatus: 1,
      };

      // console.log("Sending shiftData:", shiftData); // Debug: Log the payload

      const resp = await dispatch(addShift(shiftData));

      if (resp.payload.message === "success") {
        setLoader(false);
        resetForm();
        dispatch(loadAllShift());
        toast.success(
          isEditMode ? "Shift updated successfully" : "Shift added successfully"
        );
      } else {
        setLoader(false);
        toast.error(
          isEditMode ? "Failed to update shift" : "Failed to add shift"
        );
      }
    } catch (error) {
      // console.error("Error in onFinish:", error);
      setLoader(false);
      toast.error(
        isEditMode ? "Failed to update shift" : "Failed to add shift"
      );
    }
  };

  const onFinishFailed = ({ errorFields }) => {
    const errorMessages = errorFields
      .map((field) => field.errors.join(", "))
      .join("; ");
    toast.warning(`Please fix the following errors: ${errorMessages}`);
    setLoader(false);
  };

  const { Title } = Typography;

  return (
    <Fragment bordered={false}>
      <Row gutter={16} className="add-shift-row">
        {/* Left Side - Add/Edit Shift Form */}
        <Col xs={24} sm={24} md={10} lg={8} xl={8} className="add-shift-form-col">
          <div className="column-design border rounded card-custom">
            <Title level={4} className="m-2 mt-5 mb-5 text-center">
              {isEditMode ? "Edit Shift" : "Add Shift"}
            </Title>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              eventKey="shift-form"
              name="basic"
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 12 }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                style={{ marginBottom: "10px" }}
                label={<span className="required-label">Name</span>}
                name="ShiftName"
                rules={[
                  { required: true, message: "Please input shift name!" },
                ]}
              >
                <Input placeholder="e.g., General" />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                label={<span className="required-label">Start Time</span>}
                name="StartTime"
                rules={[
                  { required: true, message: "Please select start time!" },
                ]}
              >
                <TimePicker format="HH:mm" style={{ width: "100%" }} />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                label={<span className="required-label">End Time</span>}
                name="EndTime"
                rules={[{ required: true, message: "Please select end time!" }]}
              >
                <TimePicker format="HH:mm" style={{ width: "100%" }} />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                label={<span className="required-label">Lunch Start Time</span>}
                name="LunchStartTime"
                rules={[
                  {
                    required: true,
                    message: "Please select lunch start time!",
                  },
                ]}
              >
                <TimePicker format="HH:mm" style={{ width: "100%" }} />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                label={<span className="required-label">Lunch End Time</span>}
                name="LunchEndTime"
                rules={[
                  { required: true, message: "Please select lunch end time!" },
                ]}
              >
                <TimePicker format="HH:mm" style={{ width: "100%" }} />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                label={
                  <span className="required-label">Punch-In Grace (min)</span>
                }
                name="PunchGraceMinites"
              >
                <InputNumber placeholder="e.g., 15" min={0} step={1} />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                wrapperCol={{ offset: 6, span: 16 }}
              >
                <Space>
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    block
                    loading={loader}
                  >
                    {isEditMode ? "Update Shift" : "Add New Shift"}
                  </Button>
                  {isEditMode && (
                    <Button size="large" onClick={resetForm}>
                      Cancel
                    </Button>
                  )}
                </Space>
              </Form.Item>
            </Form>
          </div>
        </Col>

        {/* Right Side - Shift List Table */}
        <Col xs={24} sm={24} md={14} lg={16} xl={16} className="add-shift-table-col">
          <div className="ant-card p-4 rounded shift-table-container">
          <CustomTable list={shiftList} loading={loading} onEdit={handleEdit} />
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

export default AddShift;
